import ServiceContent from "@/model/Content/ServiceContent"
import { Transportation } from "@requests"
export interface ITransportServiceContent {

}

class TransportServiceContent extends ServiceContent implements ITransportServiceContent {
    private transportation: Transportation | undefined
    private transportationBack: Transportation | undefined

    constructor() { super() }

    public getTransportation() { return this.transportation }
    public getTransportationBack() { return this.transportationBack }

    public setTransportation(transportation: Transportation) { this.transportation = transportation }
    public setTransportationBack(transportationBack: Transportation) { this.transportationBack = transportationBack }

}

export default TransportServiceContent